import { Helper } from '../Helper';
const doNothing = () => {
};
export class CreateEnumeratorIterableIteratorHelper extends Helper {
    constructor(options) {
        super();
        this.mapValue = options.mapValue === undefined ? doNothing : options.mapValue;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.createIterableIteratorBase({
            handleNext: (innerOptions) => {
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                this.mapValue(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=CreateEnumeratorIterableIteratorHelper.js.map
